export interface FooterButton {
    type: FooterButtonType;
    label: string;
    showArrow?: boolean;
    disabled?: boolean;
}


export enum FooterButtonType {
    back,
    forward,
    store,
}
